// 土耳其语
module.exports = {
    public: {
        confirm: 'Onay',
        cancel: 'İptal',
        reset: 'Sıfırla',
        search: 'Ara',
        RefreshSucceeded: 'Yenileme başarılı',
        noMoreData: 'Daha fazla veri yok',
        pullingText: 'Yenilemek için çekin...',
        ReleaseText: 'Bırakın ve yenileyin...',
        loadingText: 'Yükleniyor...',
        noData: 'Kayıt yok',
        copyTxt: 'Kopyala',
        copySuccess: 'Kopyalandı',
        amount: 'Tutar',
        buy: 'Satın al',
        orderNo: 'Sipariş No',
        selectLang: 'Dil seç',
        light: 'Açık',
        dark: 'Koyu',
        All: 'Tümü',
        DigitalCurrency: 'Dijital Para',
        foreignExchange: 'Döviz',
        futures: 'Vadeli İşlem',
        stockIndex: 'Endeks',
        stock: 'Hisse',
        BalanceNot: 'Bakiye yetersiz',
        optional: 'Özel',
        market: 'Piyasa',
        USDTcontract: 'USDT Kontratı',
        Fiatcurrencycontract: 'Fiat Kontratı',
        spot: 'Spot',
        secondContract: 'Saniye Sözleşmesi',
        emptyTxt: 'Kayıt yok',
        down: 'İndir',
    },
    tabBar: {
        home: 'Ana Sayfa',
        market: 'Keşfet',
        trade: 'Ticaret',
        heel: 'Parayı yönetin.',
        asset: 'Varlık',
        my: 'Benim',
    },
    about: {
        title: 'Hakkımızda',
        version: 'Sürüm',
        about: 'Hakkında',
        ProductIntroduction: 'Ürün Tanıtımı',
        Termofservice: 'Hizmet Şartları',
        PrivacyAgreement: 'Gizlilik Sözleşmesi',
        Riskstatement: 'Risk Bildirimi',
        whitePaper: 'Beyaz Kitap',
    },
    asset: {
        Overview: 'Genel Bakış',
        contract: 'Kontrat',
        wallet: 'Cüzdan',
        Totalassetvaluation: 'Toplam Varlık Değeri',
        supportswithdrawal: 'Her varlık çekilebilir',
        Recharge: 'Yatır',
        Contractaccount: 'Kontrat Hesabı',
        Spotaccount: 'Spot Hesabı',
        Walletaccount: 'Cüzdan Hesabı',
        ValuationContractAssets: 'Kontrat Varlık Değeri',
        profitloss: 'Kâr/Zarar',
        Transfer: 'Transfer',
        occupy: 'Kilitle',
        available: 'Mevcut',
        Viewallpositions: 'Tüm Pozisyonları Görüntüle',
        Valuationspotassets: 'Spot Varlık Değeri',
        Hidezerobalanceassets: 'Sıfır bakiyeleri gizle',
        balance: 'Bakiye',
        ValuationWalletAssets: 'Cüzdan Varlık Değeri',
        Withdrawal: 'Çekim',
        Walletbalance: 'Cüzdan Bakiyesi',
        Cryptocurrencyrecharge: 'Kripto Para Yatırma',
        Fiatcurrencyrecharge: 'Fiat Yatırma',
        From: 'Kimden',
        To: 'Kime',
        UsdtContractaccount: 'USDT Kontrat Hesabı',
        FiatContractaccount: 'Fiat Kontrat Hesabı',
        Currency: 'Para Birimi',
        quantity: 'Miktar',
        availablebalance: 'Mevcut Bakiye',
        Insufficientavailablebalance: 'Bakiye yetersiz',
        Transfersuccessful: 'Transfer başarılı',
        flashcash: 'Hızlı takas',
        flashcashsuccessful: 'Hızlı takas başarılı',
    },
    auth: {
        title: 'Kimlik Doğrulama',
        gj: 'Ülke',
        tipsgj: 'Lütfen ülke seçin',
        userName: 'Gerçek İsim',
        tips1: 'Gerçek isminizi girin',
        IDNumber: 'Kimlik Numarası',
        tips2: 'Kimlik numaranızı girin',
        base: 'Temel Doğrulama',
        high: 'Gelişmiş Doğrulama',
        zmz: 'Ön Yüz',
        bmz: 'Arka Yüz',
        tips3: 'Ön yüzü yükleyin',
        tips4: 'Arka yüzü yükleyin',
        btn: 'Gönder',
        upbtn: 'Kimliği Güncelle',
        subMsg: 'Gönderildi, onay bekleniyor',
        upMsg: 'Güncellendikten sonra tekrar incelenecek, devam edilsin mi?',
        wait: 'İncelemede',
        fail: 'Başarısız',
        success: 'Başarılı',
        cardType: 'Belge Türü',
        idCard: 'Kimlik Kartı',
        passport: 'Pasaport',
        driverlicense: 'Ehliyet',
        AssetCertification: 'Varlık doğrulaması',
        AccountType: 'Hesap türü',
        holdingamount: 'Tutulan tutar',
        Accountscreenshot: 'Hesap ekran görüntüsü',
        bankaccount: 'Banka hesabı',
        IRAaccount: 'IRA hesabı',
        stockaccount: 'Hisse senedi hesabı',
        other: 'Diğer',
        AccountTypetips: 'Lütfen hesap türünü seçin',
        Accountscreenshottips: 'Lütfen hesap ekran görüntüsünü yükleyin',
    },
    activity: {
        inviteTxt: 'Her 1 arkadaş davetiniz için {amount} USD kazanırsınız, en fazla üç seviyeli komisyon desteklenir',
        invitebtn: 'Davet ve Komisyon',
        rechargeTxt: 'Alt kullanıcınız bakiye yüklediğinde, {amount}% komisyon kazanırsınız, en fazla üç seviyeli komisyon desteklenir',
        rechargebtn: 'Yükleme Komisyonu',
        authTxt: 'Kimlik doğrulamasını başarıyla tamamladığınızda {amount} USD hediye',
        authbtn: 'Kimlik Doğrulama',
        inviteRewardTxt: '<p><strong>Davet et arkadaşını, kolayca 30 USD kazan</strong></p><p><br></p><p>1. Programın Amacı</p><p><br></p><p>Hedef kitle: Yeni ve mevcut kullanıcılar katılabilir. Mevcut kullanıcıların arkadaşlarını kaydolmaya ve belirli işlemleri tamamlamaya teşvik ederek platform kullanıcı tabanını genişletmek hedefleniyor.</p><p>Temel amaç: Referans sistemi sayesinde yeni kullanıcıların hızlı katılımı ve viral büyüme sağlanırken, davet eden kullanıcılara gerçek ödüller verilir; bu da kullanıcı bağlılığını ve sadakatini artırır.</p><p><br></p><p>2. Program Süresi</p><p><br></p><p>20.05.2023 – Süresiz (düzenli olarak değerlendirilir veya duyurularla sonlandırılabilir)</p><p><br></p><p>3. Katılımcılar</p><p><br></p><p>Platforma kayıtlı ve temel kimlik doğrulamasını tamamlamış tüm kullanıcılar davet eden (A) olabilir.</p><p>Davet edilen (B), davet bağlantısı veya koduyla yeni kaydolmalı ve kimlik doğrulamasını tamamlamalıdır.</p><p><br></p><p>4. Katılım Kuralları</p><p><br></p><p>Davet Yöntemi:</p><p>Davet eden (A), “Profil” → “Arkadaş Davet Et” → kendi davet bağlantısını/kodunu kopyalar;</p><p>Bağlantı/kodu arkadaşına (B) gönderir, B web veya uygulama üzerinden kaydolur.</p><p><br></p><p>Davet edilenin Gereksinimleri:</p><p>B, A’nın davet bağlantısını/kodunu kullanarak ilk kaydını yapmalıdır;</p><p>Kayıttan sonra 7 gün içinde kimlik doğrulaması tamamlanmalı ve minimum para yatırma (ilk yatırım ≥ 1000 USD veya eşdeğer) yapılmalıdır.</p><p><br></p><p>Seviye Yapısı:</p><p>Maksimum 3 seviye komisyon sunulur.</p><p>Seviye 1 (doğrudan): A doğrudan B’yi davet eder;</p><p>Seviye 2: B C’yi davet ederse, A seviye 2 komisyonu alır;</p><p>Seviye 3: C D’yi davet ederse, A seviye 3 komisyonu alır;</p><p>Seviye 4 ve sonrası (D E’yi davet ederse vb.) A’nın kazancına dahil edilmez.</p><p><br></p><p>5. Ödül Detayları</p><p><br></p><p>Seviye 1 Ödülü (doğrudan):</p><p>B para yatırıp kimlik doğrulamasını tamamladığında, A 30 USD alır.</p><p><br></p><p>Seviye 2 Ödülü (dolaylı):</p><p>B C’yi davet eder ve C şartları karşılar; A 15 USD alır.</p><p><br></p><p>Seviye 3 Ödülü:</p><p>C D’yi davet eder ve D şartları sağlarsa, A 10 USD alır.</p><p><br></p><p>Ödül Dağıtım Yöntemi:</p><p>Sistem otomatik olarak 3 seviye ilişkisini tespit eder. Alt kullanıcı (doğrudan veya dolaylı) şartları sağladığında, A’nın varlık hesabına <strong>48 saat içinde</strong> ödül gönderilir.</p><p><br></p><p>6. Örnek Süreç:</p><p><br></p><p>A GlobalEx’a giriş yapar → “Profil” → “Arkadaş Davet Et” → bağlantıyı/kodu kopyalar;</p><p>A bunu B’ye gönderir;</p><p>B bağlantıyı tıklar veya kodu girer → e-posta ile kayıt olur → kimlik doğrular ve ≥ 1000 USD yatırır;</p><p>B tamamladıktan sonra destek hizmetine başvurur, sistem inceler ve A’ya 30 USD gönderir (<strong>48</strong> saat içinde);</p><p>B C’yi davet ederse ve C şartları sağlarsa, A 15 USD; C D’yi davet ederse, A 10 USD alır.</p><p><br></p><p>7. Risk Kontrolü & Notlar</p><p><br></p><p>Dolandırıcılık Önlemleri:</p><p>Her telefon numarası/e‑posta yalnızca bir kez davet edilebilir; aynı IP, kimlik belgesi vb. risk sistemi tarafından kontrol edilir;</p><p>Kalitesiz hesaplar veya aynı cihaz/ağ üzerinden toplu kayıt yapılırsa, sistem manuel inceleme yapabilir ve ödülleri iptal edebilir;</p><p><br></p><p>Punitive Measures:</p><p>Eğer davet eden veya davet edilen, sistem üzerinden kötü niyetli ödül suistimali ya da yasadışı çekim yaparsa, platform ödülleri iptal etme ve hesabı dondurma hakkını saklı tutar.</p><p><br></p>',
        rechargeRewardTxt: '<p><strong>Alt kullanıcı yatırımlarından komisyon, kârı anında al</strong></p><p><br></p><p><strong>1. Programın Amacı</strong></p><p><br></p><p>Hedef kitle: Kimlik doğrulamasını tamamlamış ve en az bir alt kullanıcı (B, C, D) davet etmiş Seviye 1 davet eden (A); bu alt kullanıcılar platforma yatırım yaptığında, belirlenen oranlarda komisyon alır—bu sayede ağ genişlemesi ve kullanıcı aktivitesi desteklenir.</p><p><br></p><p>Temel amaç: “Yatırımlardan komisyon” mekanizması ile yeni kullanıcıların yatırım eylemleri davet edenlerin kazancına bağlanır. Bu da “davet – yatırım – komisyon – tekrar davet” döngüsü oluşturarak platforma fon tutmayı ve kullanıcı katılımını geliştirir.</p><p><br></p><p><strong>2. Program Süresi</strong></p><p><br></p><p>20.05.2023’ten itibaren sürekli devam eder; komisyon oranları veya süre ihtiyaca göre duyurulur.</p><p><br></p><p><strong>3. Katılımcılar</strong></p><p><br></p><p>Davet eden A: Kimlik doğrulaması tamamlanmış ve en az bir B’yi davet etmiş olmalıdır.</p><p><br></p><p>Alt kullanıcılar B, C, D: A tarafından ya da alt kullanıcıları tarafından davet edilir; yatırım yaptıklarında A komisyon alır.</p><p><br></p><p><strong>4. Katılım Kuralları</strong></p><p><br></p><p><strong>Seviye Yapısı:</strong></p><p>Seviye 1 (B doğrudan): B ≥ 1000 USD yatırır → A %1 komisyon alır;</p><p>Seviye 2 (C): C ≥ 1000 USD yatırır → A %0.5 komisyon alır;</p><p>Seviye 3 (D): D ≥ 1000 USD yatırır → A %0.3 komisyon alır;</p><p>Sadece 3 seviye desteklenir.</p><p><br></p><p><strong>Yatırım Kanalları & Minimum Tutar:</strong></p><p>Platformdaki tüm yatırım yöntemleri desteklenir (fiat veya kripto), ancak her yatırım ≥ 1000 USD olmalıdır ki komisyona dahil edilsin;</p><p><br></p><p><strong>Komisyon Oranları:</strong></p><p>Seviye 1: %1,0 (örnek: B 1000 USD yatırır → A 10 USD alır);</p><p><br></p><p>Seviye 2: %0.5 (C 1000 USD yatırır → A 5 USD alır);</p><p><br></p><p>Seviye 3: %0.3 (D 1000 USD yatırır → A 3 USD alır);</p><p><br></p><p><strong>Komisyon Dağıtımı:</strong></p><p>Platform, yatırım hesabınıza yansıdıktan sonra 24 saat içinde komisyonu A’nın hesabına otomatik gönderir;</p><p>Kullanıcı “Cüzdanım” → “Komisyon Detayları” kısmından kaynak ve zaman bilgilerini görebilir;</p><p><br></p><p>5. Örnek İşlem Akışı:</p><p><br></p><p>A uygulamaya giriş yapar → “Profil” → “Arkadaş Davet Et” → bağlantıyı/kodu kopyalar;</p><p>A bu bilgiyi B’ye gönderir;</p><p>B kayıt olur → kimlik doğrular → ≥ 1000 USD yatırır;</p><p>Para hesabınıza geçince sistem otomatik hesap yapar: yatırım toplamı × 1% = A’nın alacağı komisyon; 24 saat içinde hesaba aktarılır;</p><p><br></p><p>B doğrulamayı tamamladıktan sonra C’yi davet edebilir; C yatırım yaparsa:</p><p>B, C yatırımı × 1% komisyon alır;</p><p>A, C yatırımı × 0.5% komisyon alır;</p><p><br></p><p>C D’yi davet ederse; D yatırım yaparsa:</p><p>C, D yatırımı × 1%;</p><p>B, D yatırımı × 0.5%;</p><p>A, D yatırımı × 0.3%;</p><p><br></p><p><strong>6. Risk Kontrolü & Notlar:</strong></p><p><br></p><p><strong>Kötüye Kullanımı Önleme:</strong></p><p>Aynı kullanıcı döngüsel işlem yapmamalıdır; küçük işlemler ve hızlı çekimler sistem tarafından denetlenir ve gerekirse komisyon iptal edilir;</p><p>Hızlı çekim veya yüksek frekanslı işlem tespit edilirse sistem komisyonu iptal edebilir;</p><p><br></p><p><strong>Yasal Uyumluluk:</strong></p><p>Platform, kara para aklama veya yasadışı çekim riski tespit ederse komisyonları askıya alabilir ve yetkili mercilere bildirebilir.</p><p><br></p>',
        authRewardTxt: '<p><strong>Kimlik doğrulaması yap, hemen 50 USD al</strong></p><p><br></p><p>1. Programın Amacı</p><p><br></p><p>Hedef kitle: Kimlik doğrulaması daha önce yapılmamış yeni ve mevcut kullanıcılar katılabilir; amacı kullanıcıları doğrulamaya teşvik etmek, platforma bağlılık sağlamak ve doğrulama sürecindeki kararsızlığı azaltmaktır.</p><p>Temel amaç: Doğrudan nakit ödülle kullanıcıları kimlik doğrulamasına teşvik ederek risk kontrol kalitesini ve KYC kapsamını artırmak, platformun yasal düzenlemelere uygun çalışmasını sağlamak.</p><p><br></p><p>2. Program Süresi</p><p><br></p><p>20.05.2023 – Süresiz</p><p><br></p><p>3. Katılımcılar</p><p><br></p><p>Yeni kullanıcı: GlobalEx’a ilk kaydını yapar ve kampanya süresince kimlik doğrulamasını tamamlar.</p><p>Mevcut kullanıcı: Daha önce kayıtlı ancak kimlik doğrulamasını tamamlamamışsa, kampanya süresince doğrulama yaparak ödül alabilir.</p><p><br></p><p>4. Kimlik Doğrulama Kuralları</p><p><br></p><p>Gereksinimler:</p><p>Belgenin (TC kimlik/pasaport/ehliyet) açık ve net fotoğraflarının (her iki yüz) yanı sıra belgeyi elinde tutan yarı vücut fotoğraf;</p><p>Yüz tanıma işlemi için yeterli ışık, gözlerin görünür olması ve canlılık kontrollerine uygunluk;</p><p>Gönderimden sonra doğrulama genellikle 24 saat içinde tamamlanır;</p><p><br></p><p>Ödül:</p><p>Kampanya süresince kimlik doğrulamasını tamamlayan tüm kullanıcılar (yeni veya mevcut) 50 USD alır;</p><p><br></p><p>Ödül Dağılımı:</p><p>Sistem, kimlik doğrulaması tamamlandıktan sonra 24 saat içinde 50 USD’yi fiat-sözleşme hesabına aktarır; ardından 10 normal işlemden sonra para çekilebilir;</p><p><br></p><p>Eğer bilgi eksikse veya doğrulama reddedilirse, kullanıcı eksik bilgileri tamamlayıp yeniden doğrulamalıdır.</p><p><br></p><p>5. Örnek Akış:</p><p><br></p><p>Kullanıcı uygulamaya giriş yapar → “Kimlik Doğrulaması” → süreci başlatır;</p><p>Belgenin (kimlik/pasaport/ehliyet) iki yüzünü yükler;</p><p>Sistem otomatik eşleştirme yapar; başarısızsa yeniden yükleme istenir;</p><p>Onaylandıktan sonra sistem 24 saat içinde 50 USD’yi fiat-sözleşme hesabına aktarır;</p><p><br></p><p>6. Risk Kontrolü & Notlar:</p><p><br></p><p><strong>Dolandırıcılığı Önleme:</strong></p><p>Her belge yalnızca bir kez ödül alabilir; aynı IP/cihaz üzerinden birden çok belge yüklenirse sistem bunu kontrol eder veya reddeder;</p><p>Sahte veya düzenlenmiş belge tespit edilirse doğrulama reddedilir ve hesap engellenir;</p><p><br></p><p><strong>Veri Koruma:</strong></p><p>Platform, belgeleri ve biyometrik verileri yalnızca KYC ve risk kontrolü için kullanmayı taahhüt eder; izin alınmadan paylaşılmaz;</p><p>Doğrulama sonrası belgeler ve videolar yasal düzenlemelere uygun şekilde şifrelenerek saklanır;</p><p><br></p><p>&nbsp;</p>'
    },
    bill: {
        title: 'Finans Detayları',
        audit: 'İncelemede',
        success: 'Başarılı',
        refuse: 'Reddedildi',
        recharge: 'Yatırma',
        recharge_currency: 'Kripto Yatırma',
        recharge_legal: 'Fiat Yatırma',
        withdrawal: 'Çekim',
        withdrawal_currency: 'Kripto Çekme',
        cancel_withdrawal_currency: 'Çekimi İptal Et',
        withdrawal_legal: 'Fiat Çekme',
        cancel_withdrawal_legal: 'Fiat Çekimini İptal Et',
        transfer: 'Transfer',
        usdt_contract_wallet: 'USDT Kontrat -> Cüzdan',
        legal_contract_wallet: 'Fiat Kontrat -> Cüzdan',
        coin_currency_wallet: 'Spot -> Cüzdan',
        wallet_usdt_contract: 'Cüzdan -> USDT Kontrat',
        wallet_legal_contract: 'Cüzdan -> Fiat Kontrat',
        wallet_coin_currency: 'Cüzdan -> Spot',
        finance_wallet: 'Parayı yönetin -> Cüzdan',
        wallet_finance: 'Cüzdan -> Parayı yönetin',
        usdt_contract_currency: 'USDT Kontratı -> Spot',
        finance_currency: 'Finans -> Spot',
        currency_usdt_contract: 'Spot -> USDT Kontratı',
        currency_finance: 'Spot -> Finans',
        legal_contract_currency: 'Fiat sözleşmesi -> Spot',
        currency_legal_contract: 'Spot -> Fiat sözleşmesi',
        recharge_reward: 'Alt kullanıcının yatırma komisyonu',
        auth_reward: 'Kimlik doğrulama ödülü',
        flashcash: 'Hızlı takas',
        trade: 'Ticaret',
        create_order: 'Sipariş Ver',
        settlement_order: 'Sipariş Hesaplama',
        cancel_order: 'Siparişi İptal Et',
        finance_return: 'Anapara iadesi',
        finance_income: 'Yatırım getirisi',
        other: 'Diğer',
        commission_transfer: 'Komisyon Transferi',
        platform_gift: 'Platform Hediyesi',
        system_regulation: 'Denge Değişikliği',
        freeze_thaw: 'Dondurma ve buraya',
        c2c_create_order: 'C2C Sipariş Ver',
        c2c_cancel_order: 'C2C Siparişi İptal Et',
        Currency: 'Para Birimi',
        type: 'Tür',
        SelectCurrency: 'Para Birimi Seç',
        SelectType: 'Tür Seç',
        SelectDate: 'Tarih Seç',
        to: 'İle',
        Contractfunds: 'Kontrat Fonları',
        Spotfunds: 'Spot Fonları',
        Walletfunds: 'Cüzdan Fonları',
        RechargeRecord: 'Yatırma Kaydı',
        WithdrawalRecord: 'Çekim Kaydı',
        virtualcoin: 'Kripto',
        Legaltender: 'Fiat',
    },
    c2c: {
        limit: 'Limit',
        available: 'Mevcut',
        price: 'Birim fiyat',
        needpay: 'Ödemeniz gereken',
        willreceive: 'Alacağınız',
        Insufficientlimit: 'Yetersiz limit',
        Exceedinglimit: 'Limiti aşıyor',
        Exceedingavailable: 'Mevcut miktarı aşıyor',
        balance: 'Bakiye',
        InsufficientBalance: 'Yetersiz bakiye',
        OrderHistory: 'Sipariş geçmişi',
        quantity: 'Miktar',
        amountmoney: 'Tutar',
        OrderNo: 'Sipariş Numarası',
        inprogress: 'Devam ediyor',
        Completed: 'Tamamlandı',
        Cancelled: 'İptal edildi',
        all: 'Hepsi',
        chat: 'Sohbet',
        picture: '[Resim]',
        Read: 'Okundu',
        Unread: 'Okunmadı',
        inputTips: 'Mesajınızı buraya yazın',
        send: 'Gönder',
    },
    common: {
        title: 'Tüm Özellikler',
        Depositcoins: 'Kripto Yatırma',
        Rechargefiatcurrency: 'Fiat Yatırma',
        Withdraw: 'Çekme',
        documentation: 'Parayı yönetin.',
        Activecenter: 'Etkinlik Merkezi',
        Invitationforrebate: 'Davet Bonusu',
        Detailsoffunds: 'Finans Detayları',
        Positiondetails: 'Pozisyon Detayları',
        Notice: 'Bilgi',
        Aboutus: 'Hakkımızda',
        helpcenter: 'Yardım Merkezi',
        customer: 'Destek',
        Cryptocurrencywithdrawal: 'Kripto Çekme',
        Fiatmoneywithdrawal: 'Fiat Çekme',
    },
    forgotPass: {
        title: 'Şifre Sıfırla',
        btn: 'Onayla',
        Password: 'Yeni Şifre',
        placeholder: 'Yeni şifre girin',
        success: 'Başarıyla ayarlandı',
    },
    finance: {
        financeAssetAmount: 'Finansal Varlık Değeri',
        financeAccount: 'Finans Hesabı',
        financefund: 'Finansal Fon',
        financeProduct: 'Finansal Ürün',
        Applynow: 'Hemen Başvur',
        term: 'Vade',
        investment: 'Yatırım Tutarı',
        Mininvestment: 'Minimum Yatırım Tutarı',
        Maxinvestment: 'Maksimum yatırım tutarı',
        buyNum: 'Satın alma sayısı',
        Myincome: 'Gelirim',
        Dailyearnings: 'Günlük Kazanç',
        yieldmaturity: 'Vade Sonu Getirisi',
        timeaxis: 'Zaman Çizelgesi',
        Subscriptiondate: 'Başvuru Tarihi',
        valuedate: 'Faiz Başlangıç Tarihi',
        duedate: 'Vade Tarihi',
        Receiptdate: 'Tahsilat Tarihi',
        day: 'Gün',
        financeOrderList: 'Finansal Kayıtlar',
        interestrate: 'faiz oranı',
        Revenueamount: 'Getiri Tutarı',
        Settlementamount: 'Ödeme Tutarı',
        regularly: 'Vadeli',
        eecurrent: 'Vadesiz',
        redemption: 'Bozdurma',
        redemptionTips: 'Bu finansal ürünü bozdurmayı onayla',
        loan: 'Kredi',
        LoanRange: 'Kredi aralığı',
        LoanAmount: 'Kredi tutarı',
        loanTerm: 'Kredi süresi',
        Dailyinterestrate: 'Günlük faiz oranı',
        Totalinterest: 'Toplam faiz',
        Repaymentmethod: 'Geri ödeme yöntemi',
        Repaymentofmaturity: 'Vade sonunda anapara ve faizin tek seferde ödenmesi',
        Estimatedreturn: 'Tahmini ödenecek tutar',
        Ihavereadandagree: 'Okudum ve kabul ediyorum',
        LoanAgreement: 'Kredi sözleşmesi',
        Immediatelymoney: 'Hemen kredi al',
        Minimumloanamount: 'Minimum kredi tutarı',
        Maximumloanamount: 'Maksimum kredi tutarı',
        Applicationsuccessfulreview: 'Başvuru başarılı, sistem incelemesi bekleniyor',
        Loanrecords: 'Kredi kayıtları',
        Pendingreview: 'İnceleme bekleniyor',
        issued: 'Tahsis edildi',
        Repaid: 'Ödendi',
        Rejected: 'Reddedildi',
        LoanDate: 'Kredi tarihi',
        AmountDue: 'Ödenecek tutar',
        repayment: 'Geri ödeme',
        homeAddress: 'Detaylı ev adresi',
        homeAddressTips: 'Lütfen detaylı ev adresini girin',
        emergencyContact: 'Acil durum kişisi',
        emergencyContactTips: 'Lütfen acil durum kişisini girin',
        emergencyPhone: 'Acil durum kişisinin telefon numarası',
        emergencyPhoneTips: 'Lütfen acil durum kişisinin telefon numarasını girin',
        emergencyEmail: 'Acil durum kişisinin e-postası',
        emergencyEmailTips: 'Lütfen acil durum kişisinin e-postasını girin',
        isHouse: 'Kendi mülkünüz var mı',
        houseImg: 'Mülkünüz varsa, mülkiyet kanıtı görseli yükleyin',
        certImg: 'Belgenin ön yüzü (Kimlik/Pasaport/Sürücü belgesi)',
        certImgTips: 'Lütfen belgenin ön yüzünü yükleyin (Kimlik/Pasaport/Sürücü belgesi)',
        certBackImg: 'Belgenin arka yüzü (Kimlik/Pasaport/Sürücü belgesi)',
        certBackImgTips: 'Lütfen belgenin arka yüzünü yükleyin (Kimlik/Pasaport/Sürücü belgesi)',
        trustImg: 'Kredi puanı ekran görüntüsü',
        trustImgTips: 'Lütfen kredi puanı ekran görüntüsünü yükleyin',
        yesTxt: 'Evet',
        noTxt: 'Hayır',
        EstimatedReturn: 'Tahmini getiri',
        seeDetail: 'Detayları gör',
        orderDetails: 'Sipariş detayları',
        simFinanceTips: 'Lütfen finans fonksiyonunu kullanmak için gerçek hesaba geçin',
    },
    heel: {
        tips: 'Yakında!',
    },
    home: {
        optional: 'Özel',
        HotList: 'Popüler Liste',
        more: 'Daha Fazla',
        Welcomeback: 'Tekrar hoş geldiniz',
        loginBtn: 'Giriş Yap',
        CompleteAuth: 'Tüm hizmetlerin kilidini açmak için kimlik doğrulamasını tamamlayın',
        authBtn: 'Hemen Doğrula',
        toptit1: 'Her zaman, her yerde işlem yapın',
        toptit2: 'Tek tıkla yatırım yapın, kolayca kazanç sağlayın!',
    },
    login: {
        title: 'Giriş Yap',
        Account: 'Hesap',
        Password: 'Şifre',
        btn: 'Giriş',
        placeholder: 'Telefon numaranızı girin',
        placeholder1: 'Şifrenizi girin',
        ForgotPassword: 'Şifremi Unuttum',
        noAccount: 'Hesabınız yok mu?',
        Registration: 'Kaydol',
        server: 'Destek',
        success: 'Başarıyla giriş yapıldı',
        checkedAgree: 'Önce gizlilik sözleşmesini kabul edin',
        rememberpassword: 'Şifreyi Hatırla',
        agreewith: 'Kabul Ediyorum',
        PrivacyAgreement: 'Gizlilik Sözleşmesi',
    },
    market: {
        product: 'Ürün',
        Latestprice: 'Son Fiyat',
        volume: 'Hacim',
        ChangeRatio: 'Değişim %',
        Addoptional: 'Favorilere Ekle',
        optional: 'Favori',
        market: 'Piyasa',
        Editselfselection: 'Favorileri Düzenle',
        operate: 'İşlem',
        SelectAll: 'Tümünü Seç',
        delete: 'Sil',
        time: 'Zaman',
    },
    position: {
        title: 'Pozisyon Detayı',
        totalassets: 'Toplam Varlık',
        profitloss: 'Kâr/Zarar',
        Holdingassets: 'Pozisyon Varlığı',
        margin: 'Marjin',
        orderAmount: 'Sipariş Tutarı',
        availableassets: 'Kullanılabilir Varlık',
        product: 'Ürün',
        direction: 'Yön',
        Entrustedprice: 'Emir Fiyatı',
        Entrustednum: 'Emir Adedi',
        Currentprice: 'Mevcut Fiyat',
        Stoplossprice: 'Zarar Durdur',
        stopSurplusPrice: 'Kâr Al',
        Leverageratio: 'Kaldıraç',
        Entrustedtime: 'Emir Zamanı',
        orderno: 'Sipariş No',
        marketvalue: 'Piyasa Değeri',
        SettlementPrice: 'Uzlaşma Fiyatı',
        Settlementtime: 'Uzlaşma Zamanı',
        Settakeprofitloss: 'Kâr/Zarar Ayarla',
        closeposition: 'Pozisyon Kapat',
        Position: 'Açık Emirler',
        commission: 'Geçmiş Emirler',
        Settlement: 'Geçmiş İşlemler',
        Settingsuccessful: 'Başarıyla Ayarlandı',
        Confirmclosingorder: 'Emri Kapatmayı Onayla',
        Closingsuccessfully: 'Başarıyla Kapandı',
        cancelorder: 'Emri İptal Et',
        Cancelsuccessfully: 'Başarıyla İptal Edildi',
        status: 'Durum',
        changeRate: 'Ücret',
    },
    property: {
        title: 'Varlık Detayı',
        totalassets: 'Toplam Varlık',
        profitloss: 'Kâr/Zarar',
        Holdingassets: 'Pozisyon Varlığı',
        margin: 'Marjin',
        availableassets: 'Kullanılabilir Varlık',
        investmentportfolio: 'Yatırım Portföyü',
        Recentincomesituation: 'Son Kazanç Durumu',
        Seemore: 'Daha Fazla Gör',
        IncomeDetails: 'Kazanç Detayı',
    },
    recharge: {
        mixAmount: 'Min. Yatırım:',
        subMsg: 'Başarıyla Gönderildi, Onay Bekleniyor',
        amountMsg: 'Lütfen Miktar Girin',
        VoucherMsg: 'Lütfen Ödeme Belgesi Yükleyin',
        Depositcoins: 'Kripto Yatır',
        Rechargecurrency: 'Yatırım Para Birimi',
        RechargecurrencyTips: '200USDT Üzeri Hızlı İşlem',
        Depositaddress: 'Yatırım Adresi',
        Rechargetoaccount: 'Hesaba Yatır',
        Walletaccount: 'Cüzdan Hesabı',
        Rechargequantity: 'Yatırım Miktarı',
        Paymentvoucher: 'Ödeme Belgesi',
        Youneedtorecharge: 'Yatırmanız Gereken',
        Rechargenow: 'Hemen Yatır',
        Rechargefiatcurrency: 'Fiat Yatırım',
        Topupfiatcurrency: 'Fiat Para Yatır',
        paymentcurrency: 'Ödeme Para Birimi',
        paymentcurrencyTips: '200USD Üzeri Hızlı İşlem',
        Fiatcontractaccount: 'Fiat Kontrat Hesabı',
        Rechargeamount: 'Yatırım Tutarı',
        Youwillget: 'Alacağınız',
        network: 'Ağ',
        notsupportedAddress: 'Geçerli adres desteklenmiyor',
        selectaccount: 'Lütfen hesap seçin',
    },
    register: {
        title: 'Kayıt Ol',
        send: 'Kod Gönder',
        Resend: 'Tekrar Gönder',
        sendSuccess: 'Başarıyla Gönderildi',
        PhoneNumber: 'Telefon Numarası',
        Mailbox: 'E-posta',
        Captcha: 'Doğrulama Kodu',
        Password: 'Şifre',
        ConfirmPassword: 'Şifreyi Onayla',
        PromoteCode: 'Promosyon Kodu',
        OrgCode: 'Kuruluş Kodu',
        btn: 'Kayıt Ol',
        placeholder0: 'Telefon Numaranızı Girin',
        placeholder1: 'Şifrenizi Girin',
        placeholder2: 'Şifreyi Onaylayın',
        placeholder3: 'Referans Kodu Girin',
        placeholder4: 'Kod Girin',
        placeholder5: 'E-posta Girin',
        emaiError: 'Geçersiz E-posta Formatı',
        success: 'Kayıt Başarılı',
        message: 'Şifre En Az 6 Karakter',
        message1: 'Onay Şifresi En Az 6 Karakter',
        message2: 'Şifreler Uyuşmuyor',
        searchCountryMsg: 'Ülke/Kod Ara',
        haveAccount: 'Zaten Hesabın Var mı?',
        goLogin: 'Giriş Yap',
        titleTips: 'Kayıtla Başlayın!',
        Invitationcode: 'Davet Kodu',
        Iagreewith: 'Hesap Oluşturarak',
        and: 've',
    },
    safe: {
        SecuritySettings: 'Güvenlik Ayarları',
        Accountsecurity: 'Hesap Güvenliği',
        phone: 'Telefon',
        Notyetbound: 'Bağlı Değil',
        mailbox: 'E-posta',
        Loginpassword: 'Giriş Şifresi',
        Fundcode: 'Fon Şifresi',
        Settings: 'Ayarlar',
        Withdrawaladdressmanagement: 'Çekim Adresleri',
        Addwithdrawaladdress: 'Çekim Adresi Ekle',
        Withdrawalcurrency: 'Çekim Para Birimi',
        Withdrawaladdress: 'Çekim Adresi',
        WithdrawaladdressTips: 'Lütfen Çekim Adresi Girin',
        WithdrawaladdressError: 'Lütfen geçerli bir para çekme adresi girin',
        remark: 'Açıklama',
        confirm: 'Onayla',
        Addedsuccessfully: 'Başarıyla Eklendi',
        Pleaseselectcurrency: 'Lütfen Para Birimi Seçin',
        Bindmailbox: 'E-posta Bağla',
        Bindmobilephone: 'Telefon Bağla',
        ChangeLoginPassword: 'Giriş Şifresini Değiştir',
        Setfundpassword: 'Fon Şifresi Belirle',
        BindmailboxTips: 'Önce E-postayı Bağlayın, Bağlamak İster misiniz?',
        Addnewaddress: 'Yeni Adres Ekle',
        Confirmdeleteaddress: 'Bu Çekim Adresini Silmeyi Onaylıyor musunuz?',
    },
    share: {
        title: 'Paylaşarak Kazan',
        commission: 'Komisyon',
        Commissionrecord: 'Komisyon Kaydı',
        Commissiontransferout: 'Komisyon Çekimi',
        Transferoutrecord: 'Çekim Kaydı',
        Invitefriends: 'Arkadaş Davet Et',
        Invitationrecord: 'Davet Kaydı',
        Commissioncommission: 'Komisyon Payı',
        ReferralCode: 'Referans Kodu',
        Firstlevelmembers: '1. Seviye Üyeler',
        Secondlevelmembers: '2. Seviye Üyeler',
        Thirdlevelmembers: '3. Seviye Üyeler',
        Transferbalance: 'Bakiye Aktar',
        Confirmtransferout: 'Çekimi Onayla',
        Transfersuccessful: 'Çekim Başarılı',
        amount: 'Çekim Tutarı',
        Transferfiaaccount: 'Sözleşme hesabına aktar',
    },
    trade: {
        high: '24saat Yüksek',
        low: '24saat Düşük',
        vol: '24saat Hacim',
        buy: 'Al',
        sell: 'Sat',
        buyBtn: 'Al',
        sellBtn: 'Sat',
        Present: 'Piyasa Emri',
        Limit: 'Limit Emri',
        limitMsg: 'Fiyat',
        markPriceMsg: 'En iyi fiyattan',
        num: 'Miktar',
        zyzsSet: 'Zarar/Kâr Durdur Ayarla',
        zyPrice: 'Kâr Durdur',
        zsPrice: 'Zarar Durdur',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: 'Pozisyon',
        Viewalltransactions: 'Tüm İşlemleri Görüntüle',
        product: 'Ürün',
        direction: 'Yön',
        Entrustedprice: 'Emir Fiyatı',
        Entrustednum: 'Emir Miktarı',
        Latestprice: 'Son Fiyat',
        volume: 'Hacim',
        ChangeRatio: 'Değişim %',
        buyBtnConfirm: 'Satın Almayı Onayla',
        sellBtnConfirm: 'Satmayı Onayla',
        totalAmount: 'Tutar',
        Margin: 'Marjin',
        balance: 'Kullanılabilir',
        buyLimtMsg: 'Uzun pozisyon için piyasa fiyatından düşük fiyat girin',
        sellLimtMsg: 'Kısa pozisyon için piyasa fiyatından yüksek fiyat girin',
        putNummsg: 'Lütfen miktarı girin',
        putLimitPriceMsg: 'Lütfen limit fiyatı girin',
        pleaseAuth: 'Lütfen kimlik doğrulaması yapın',
        orderSuccess: 'İşlem Başarılı',
        Fullwarehouse: 'Tam Pozisyon',
        corkado: 'Açılabilir Uzun',
        Kato: 'Uzun Aç',
        openable: 'Açılabilir Kısa',
        Openempty: 'Kısa Aç',
        purchasable: 'Alınabilir',
        vendibility: 'Satılabilir',
        Orderconfirmation: 'Emri Onayla',
        Averageopeningprice: 'Açılış Fiyatı',
        Marketprice: 'Piyasa Fiyatı',
        Openingquantity: 'Açılış Miktarı',
        Stoplossprice: 'Zarar Durdur Fiyatı',
        stopSurplusPrice: 'Kâr Durdur Fiyatı',
        Averageprice: 'Ortalama Fiyat',
        buyLimtMsg2: 'Alış, piyasa fiyatından düşük bir fiyatla yapılmalıdır',
        sellLimtMsg2: 'Satış, piyasa fiyatından yüksek bir fiyatla yapılmalıdır',
        authTips: 'Lütfen kimliğinizi doğrulayın, doğrulama için tıklayın',
        profundity: 'Derinlik',
        deal: 'İşlem',
        contract: 'Kontrat',
        TradeNow: 'Şimdi İşlem Yap',
        CloseTime: 'Kapalı Pazar',
        buyUp: 'Yükseliş Al',
        buyDown: 'Düşüş Al',
        selectSeconds: 'Vade Süresini Seç',
        buyNums: 'Alım Miktarı',
        minbuyNums: 'Minimum Alım',
        incomeRates: 'Getiri Oranı',
        buySuccessTips: 'Satın Alma Başarılı',
        secondNums: 'Saniye',
        simulatedTrading: 'Simüle İşlem',
    },
    upPassword: {
        title: 'Şifreyi Değiştir',
        oldPassword: 'Eski Şifre',
        oldPasswordMsg: 'Eski şifrenizi girin',
        newPassword: 'Yeni Şifre',
        newPasswordMsg: 'Yeni şifrenizi girin',
        twoPassword: 'Şifreyi Onayla',
        twoPasswordMsg: 'Şifreyi onaylayın',
        twoinputMsg: 'Şifreler uyuşmuyor',
        passwordTypeMsg: 'Şifre 6 haneli sayı olmalıdır',
        submsg: 'Başarıyla değiştirildi',
        btn: 'Değişikliği Onayla',
    },
    user: {
        Avatarchange: 'Profil Resmi Değiştir',
        Replacesuccessfully: 'Başarıyla Değiştirildi',
        authenticated: 'Doğrulanmış',
        Notcertifiedyet: 'Henüz Doğrulanmamış',
        Invitefriends: 'Arkadaş Davet Et',
        Activecenter: 'Aktivite Merkezi',
        Identityauthentication: 'Kimlik Doğrulama',
        Completedverification: 'Doğrulama Tamamlandı',
        Tobeverified: 'Onay Bekliyor',
        SecuritySettings: 'Güvenlik Ayarları',
        Lang: 'Dil Seç',
        changeTheme: 'Tema Değiştir',
        helpcenter: 'Yardım Merkezi',
        Aboutus: 'Hakkımızda',
        out: 'Çıkış Yap',
        outmsg: 'Çıkış yapmak istediğinizden emin misiniz?',
        trustscore: 'Kredi puanı',
    },
    welcome: {
        title1: 'Sektörde Lider Piyasa Likiditesi',
        tips1: '99% emir en iyi fiyatla gerçekleştirilir',
        title2: '12 Yıllık Güven',
        tips2: 'Her Yerde Kripto Para Ticaretine Güvenle Erişin',
        title3: 'VIP Özel İmkanları',
        tips3: 'VIP Olun, ticaret, değişim ve para çekme işlemlerinde indirimler kazanın',
        title4: '100.000USDT Simülasyon Hesabı',
        tips4: 'Risk almadan ticaret yapın',
        bnt1: 'Hemen Kayıt Ol, 10 USDT Al',
        bnt2: 'Giriş Yap',
    },
    with: {
        Withdrawcurrency: 'Çekim',
        currencyofwithdrawal: 'Çekim Para Birimi',
        Withdrawaladdress: 'Çekim Adresi',
        Addwithdrawaladdress: 'Çekim Adresi Ekle',
        Withdrawalquantity: 'Çekim Miktarı',
        availablebalance: 'Kullanılabilir Bakiye',
        WithdrawaladdressTips: 'Bu para birimi için çekim adresi ayarlanmamış, ayarlamak ister misiniz?',
        selectWithdrawaladdress: 'Çekim Adresi Seçin',
        Insufficientavailablebalance: 'Yetersiz Bakiye',
        Withdrawingfiatcurrency: 'Fiat Para Çekimi',
        Withdrawaloffiatcurrency: 'Fiat Para Çekimi',
        Currentbalance: 'Mevcut Bakiye',
        Currencyreceived: 'Alınan Para Birimi',
        WithdrawingfiatcurrencyTips: 'Çekim 200USD Üzerinde ise Hızlı İşlem',
        Withdrawalaccount: 'Çekim Hesabı',
        Fiatcontractaccount: 'Fiat Kontrat Hesabı',
        Withdrawalamount: 'Çekim Tutarı',
        Youneedwithdrawmoney: 'Çekmeniz gereken miktar',
        Youwillget: 'Alacağınız Miktar',
        Withdrawimmediately: 'Hemen Çekim Yap',
        mixAmount: 'Min. Çekim Tutarı ',
        subMsg: 'Başarıyla Gönderildi, Onay Bekliyor',
    },
}